<div role="alert" class="alert w-100 alert-danger" *ngIf="invalidCredentials$ | async"><strong>{{'admin.alerts.headerError' | translate}}</strong> {{'admin.alerts.invalidCredentials' | translate}} </div>
<form [formGroup]="loginForm" class="pb-0 pt-4">
  <div class="col-lg-12">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-lg-12 col-md-12 col-sm-12">{{'admin.passwordAuth.passAuthPromt' | translate}}</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-xl-2 col-lg-3 col-md-12 col-sm-12 required" for="username">{{'admin.global.email' | translate}}</label>
          <div class="col-xl-10 col-lg-9 col-md-12 col-sm-12">
            <input type="text" class="form-control" [class.is-invalid]="username.invalid && (username.dirty || username.touched)" autocomplete="username" required formControlName="username" disabled />
            <div class="invalid-feedback" *ngIf="username.errors && username.errors.required">{{'admin.global.field.required' | translate}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-xl-2 col-lg-3 col-md-12 col-sm-12 required" for="password">
            {{'admin.global.password' | translate}}
          </label>
          <div class="input-group col-xl-10 col-lg-9 col-md-12 col-sm-12">
            <input type="password" class="form-control" [class.is-invalid]="password.invalid && (password.dirty || password.touched)" autocomplete="current-password" required formControlName="password" maxlength="100" />
            <div class="invalid-feedback" *ngIf="password.errors && password.errors.required">
              {{'admin.global.field.required' | translate}}
            </div>
            <div class="invalid-feedback" *ngIf="password.errors && password.errors.minlength">
              {{'admin.global.field.minLength' | translate:{minLength: password.errors.minlength.requiredLength} }}.
            </div>
            <div class="invalid-feedback" *ngIf="password.errors && password.errors.maxlength">
              {{'admin.global.field.maxLength' | translate:{maxLength: password.errors.maxlength.requiredLength} }}.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <button type="button" class="btn btn-primary" (click)="loginAction()" [disabled]="loginForm.invalid">
        {{'admin.passwordAuth.passAuthButton' | translate}}
      </button>
    </div>
  </div>
</form>
